import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import InboxMessageCard from "./InboxMessageCard";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import { Divider } from "antd";

const MessageListPanel = ({
  messages,
  selectedMessage,
  onSelect,
  starredMessages,
  onToggleStar,
}) => {
  return (
    <HeaderComponent
      title="Messages"
      description={`${messages.length} messages`}
      bgcolor="gradient light-indigo"
    >
      <div className="space-y-3 mt-4">
        <SearchBar placeholder="Search by name, position or ID..." />
        <SelectOption
          placeholder="All Messages"
          options={[
            { label: "All Messages", value: 0 },
            { label: "Reports", value: 1 },
            { label: "Policies", value: 2 },
            { label: "Meetings", value: 3 },
            { label: "Billings", value: 4 },
            { label: "Updates", value: 5 },
            { label: "System", value: 6 },
          ]}
        />

        <Divider />

        <div className="overflow-y-auto h-[60vh]">
          <InboxMessageCard
              messages={messages}       
              selectedMessage={selectedMessage}
              onClick={onSelect}               
              starredMessages={starredMessages}
              onToggleStar={onToggleStar}
            />
        </div>
      </div>
    </HeaderComponent>
  );
};

export default MessageListPanel;
